import React from 'react';
import { Grid } from 'semantic-ui-react';
import './styles.less';
import { Field, FieldArray } from 'redux-form';
import PropTypes from 'prop-types';
import { FormInputField } from '../../../../../semantic-ui/components/form-input-field';
import { FormSelectField } from '../../../../../semantic-ui/components/form-select-field';
import { CustomDatePicker } from '../../../../../semantic-ui/components/custom-datepicker';
import { ModesComponent } from '../../modes-component';
import { normalizeInteger } from '../../../../../utils/normalizeInteger';
import { TnIcon, VolumeIcon } from '../../../../../components/text-icon';

export const TrailerFormView = ({
	ownerships,
	isOwnershipsLoading,
	legals,
	isLegalsLoading,
	trailerTypes,
	isTypeDateIssueVisible,
	modes,
	isTrailerTypesLoading,
	isModesLoading,
	isOwnershipVisible,
}) => {
	return (
		<Grid className="trailer-form">
			<Grid.Row className="trailer-form__row">
				<Grid.Column width={5} className="trailer-form__column">
					Юр. лицо
				</Grid.Column>
				<Grid.Column width={9} className="trailer-form__column">
					<Field
						name="legal_id"
						type="text"
						component={FormSelectField}
						autoComplete="off"
						options={legals}
						search
						dropdownClassName="static"
						loading={isLegalsLoading}
						disabled={isLegalsLoading}
						noResultsMessage="Юр. лица не найдены"
						placeholder="Выберите юр. лицо"
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="trailer-form__row">
				<Grid.Column width={5} className="trailer-form__column">
					Модель
				</Grid.Column>
				<Grid.Column width={9} className="trailer-form__column">
					<Field
						name="name"
						type="text"
						component={FormInputField}
						autoComplete="off"
						placeholder="Укажите модель"
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="trailer-form__row">
				<Grid.Column width={5} className="trailer-form__column">
					Гос. номер
				</Grid.Column>
				<Grid.Column width={9} className="trailer-form__column">
					<Field
						name="number"
						type="text"
						component={FormInputField}
						autoComplete="off"
						placeholder="Укажите гос. номер"
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="trailer-form__row">
				<Grid.Column width={5} className="trailer-form__column">
					Vin номер
				</Grid.Column>
				<Grid.Column width={9} className="trailer-form__column">
					<Field
						name="vin"
						type="text"
						component={FormInputField}
						autoComplete="off"
						placeholder="Укажите vin номер"
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="trailer-form__row">
				<Grid.Column width={5} className="trailer-form__column">
					Тип прицепа
				</Grid.Column>
				<Grid.Column width={9} className="trailer-form__column">
					<Field
						name="type_id"
						type="text"
						component={FormSelectField}
						autoComplete="off"
						options={trailerTypes}
						search
						dropdownClassName="static"
						loading={isTrailerTypesLoading}
						disabled={isTrailerTypesLoading}
						noResultsMessage="Не найдено"
						placeholder="Выберите тип прицепа"
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="trailer-form__row">
				<Grid.Column width={5} className="trailer-form__column">
					Год выпуска прицепа
				</Grid.Column>
				<Grid.Column width={3} className="trailer-form__column">
					<Field
						name="date_issue"
						type="text"
						component={CustomDatePicker}
						autoComplete="off"
						placeholder=". . / . . "
						dateFormat={['MM.yyyy', 'MM-yyyy', 'MM/yyyy']}
						showMonthYearPicker
					/>
				</Grid.Column>
			</Grid.Row>
			{isTypeDateIssueVisible && (
				<Grid.Row className="trailer-form__row">
					<Grid.Column width={5} className="trailer-form__column">
						Год выпуска рефрижератора
					</Grid.Column>
					<Grid.Column width={3} className="trailer-form__column">
						<Field
							name="type_date_issue"
							type="text"
							component={CustomDatePicker}
							autoComplete="off"
							placeholder=". . / . . "
							dateFormat={['MM.yyyy', 'MM-yyyy', 'MM/yyyy']}
							showMonthYearPicker
						/>
					</Grid.Column>
				</Grid.Row>
			)}
			<Grid.Row className="trailer-form__row">
				<Grid.Column width={5} className="trailer-form__column">
					Грузоподъемность
				</Grid.Column>
				<Grid.Column width={9} className="trailer-form__column">
					<Field
						name="weight"
						type="text"
						normalize={normalizeInteger}
						component={FormInputField}
						autoComplete="off"
						icon={TnIcon}
						placeholder="Укажите грузоподъемность"
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="trailer-form__row">
				<Grid.Column width={5} className="trailer-form__column">
					Вместимость
				</Grid.Column>
				<Grid.Column width={9} className="trailer-form__column">
					<Field
						name="volume"
						type="text"
						normalize={normalizeInteger}
						component={FormInputField}
						autoComplete="off"
						icon={VolumeIcon}
						placeholder="Укажите вместимость"
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="trailer-form__row">
				<Grid.Column width={5} className="trailer-form__column">
					Тип владения
				</Grid.Column>
				<Grid.Column width={9} className="trailer-form__column">
					<Field
						name="ownership_id"
						type="text"
						component={FormSelectField}
						autoComplete="off"
						options={ownerships}
						search
						dropdownClassName="static"
						loading={isOwnershipsLoading}
						disabled={isOwnershipsLoading}
						noResultsMessage="Не найдено"
						placeholder="Выберите тип владения"
						isWithoutSelectOnBlur
					/>
				</Grid.Column>
			</Grid.Row>
			{isOwnershipVisible && (
				<>
					<Grid.Row className="trailer-form__row">
						<Grid.Column width={5} className="trailer-form__column">
							Название документа
						</Grid.Column>
						<Grid.Column width={9} className="trailer-form__column">
							<Field
								name="doc_name"
								type="text"
								component={FormInputField}
								autoComplete="off"
								placeholder="Укажите название документа"
							/>
						</Grid.Column>
					</Grid.Row>
					<Grid.Row className="trailer-form__row">
						<Grid.Column width={5} className="trailer-form__column">
							Номер документа
						</Grid.Column>
						<Grid.Column width={9} className="trailer-form__column">
							<Field
								name="doc_number"
								type="text"
								component={FormInputField}
								autoComplete="off"
								placeholder="Укажите номер документа"
							/>
						</Grid.Column>
					</Grid.Row>
					<Grid.Row className="trailer-form__row">
						<Grid.Column width={5} className="trailer-form__column">
							Дата выдачи документа
						</Grid.Column>
						<Grid.Column width={9} className="trailer-form__column">
							<Field
								name="doc_date"
								type="text"
								component={CustomDatePicker}
								autoComplete="off"
								placeholder=". . / . . / . . . ."
								dateFormat={['dd.MM.yyyy', 'dd-MM-yyyy', 'dd/MM/yyyy']}
							/>
						</Grid.Column>
					</Grid.Row>
				</>
			)}
			{isTypeDateIssueVisible && (
				<FieldArray name="modes" component={ModesComponent} props={{ modes, isModesLoading }} />
			)}
		</Grid>
	);
};

TrailerFormView.propTypes = {
	isTrailerInfoLoading: PropTypes.bool.isRequired,
	isOwnershipsLoading: PropTypes.bool.isRequired,
	ownerships: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.string.isRequired,
			value: PropTypes.string.isRequired,
			text: PropTypes.string.isRequired,
		}),
	).isRequired,
	legals: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.number.isRequired,
			value: PropTypes.number.isRequired,
			text: PropTypes.string.isRequired,
		}),
	).isRequired,
	isLegalsLoading: PropTypes.bool.isRequired,
	trailerTypes: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.string.isRequired,
			value: PropTypes.string.isRequired,
			text: PropTypes.string.isRequired,
		}),
	).isRequired,
	isTypeDateIssueVisible: PropTypes.bool.isRequired,
	modes: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.string.isRequired,
			value: PropTypes.string.isRequired,
			text: PropTypes.string.isRequired,
		}),
	).isRequired,
	isTrailerTypesLoading: PropTypes.bool.isRequired,
	isModesLoading: PropTypes.bool.isRequired,
	isOwnershipVisible: PropTypes.bool.isRequired,
};
